document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.custom-bottled-cocktails');
  
  sections.forEach(section => {
    // Gallery Logic
    const mainImage = section.querySelector('.custom-bottled-cocktails__main-image');
    const thumbnails = section.querySelectorAll('.custom-bottled-cocktails__thumbnail');
    
    if (mainImage && thumbnails.length > 0) {
      thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', () => {
          // Remove active class from all
          thumbnails.forEach(t => t.classList.remove('is-active'));
          // Add active class to clicked
          thumbnail.classList.add('is-active');
          
          // Get large image source and srcset
          const src = thumbnail.dataset.imageSrc;
          const srcset = thumbnail.dataset.imageSrcset;
          
          if (src) {
            mainImage.style.opacity = '0';
            setTimeout(() => {
              mainImage.src = src;
              if (srcset) {
                mainImage.srcset = srcset;
              } else {
                mainImage.removeAttribute('srcset');
              }
              mainImage.style.opacity = '1';
            }, 300); // Wait for transition
          }
        });
      });
    }

    // Modal Logic
    const orderBtn = section.querySelector('.custom-bottled-cocktails__order-btn');
    const modal = section.querySelector('.custom-bottled-cocktails__modal');
    
    if (orderBtn && modal) {
      const closeBtn = modal.querySelector('.custom-bottled-cocktails__modal-close');
      
      const openModal = () => {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
      };
      
      const closeModal = () => {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      };
      
      orderBtn.addEventListener('click', (e) => {
        e.preventDefault();
        openModal();
      });
      
      if (closeBtn) {
        closeBtn.addEventListener('click', closeModal);
      }
      
      // Close when clicking outside content
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          closeModal();
        }
      });
      
      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });
    }
  });
});

// Support Shopify Theme Editor events
document.addEventListener('shopify:section:load', (event) => {
  // Logic would normally re-initialize here, but DOMContentLoaded might not fire again
  // For robustness in editor, we trigger the DOMContentLoaded event logic on this section specifically.
  // We'll keep it simple for now as most events attach correctly initially.
});
